<template>
  <div>
    <b-row class="mb-6 d-flex">
      <b-col md="12">
        <span>
          {{
            this.$t(
              "Other products in our cyber security product suite include:"
            )
          }}</span
        >
        <b> {{ this.$t("ArcTitan, SafeTitan and SpamTitan.") }}</b>
        <span>
          {{
            this.$t(
              "Choose 'Try Now' to explore the features and benefits of these products."
            )
          }}</span
        >
      </b-col>
    </b-row>
    <b-row class="d-flex justify-content-around mr-1">
      <b-card
        class="ml-3 mb-6 b-card"
        v-for="(productLink, idx) in productLinks"
        :data-test-id="`user-menu-${productLink.title.toLowerCase()}titan`"
        :key="idx"
      >
        <b-card-text>
          <span class="d-flex align-items-center mb-4">
            <img :src="productLink.img" class="mr-2" />
          </span>
          <ul>
            <li
              v-for="(line, key) in productLink.content"
              class="mt-3"
              :key="key"
            >
              {{ $t(line) }}
            </li>
          </ul>
        </b-card-text>
        <template #footer>
          <b-button
            variant="secondary"
            class="float-center try-now"
            @click="cardClick(productLink.link)"
            >{{ $t("Try Now") }}</b-button
          >
        </template>
      </b-card>
    </b-row>
  </div>
</template>

<route>
{
  "name": "MSP Products"
}
</route>

<script>
import { mapActions } from "vuex";
import {
  PRODUCTS_LINK,
  PRODUCTS_TITLE,
  SPAM_CONTENT,
  PRODUCTS_IMG,
  ARC_CONTENT,
  SAFE_CONTENT,
} from "@/constants";
export default {
  layout: "msp",
  data() {
    return {
      productLinks: [
        {
          title: PRODUCTS_TITLE.ARC,
          link: PRODUCTS_LINK.ARC,
          img: PRODUCTS_IMG.ARC,
          content: ARC_CONTENT,
        },
        {
          title: PRODUCTS_TITLE.SAFE,
          link: PRODUCTS_LINK.SAFE,
          img: PRODUCTS_IMG.SAFE,
          content: SAFE_CONTENT,
        },
        {
          title: PRODUCTS_TITLE.SPAM,
          link: PRODUCTS_LINK.SPAM,
          img: PRODUCTS_IMG.SPAM,
          content: SPAM_CONTENT,
        },
      ],
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle"]),
    cardClick(link) {
      // eslint-disable-next-line security/detect-non-literal-fs-filename
      window.open(link, "_blank");
    },
  },
  created() {
    this.setPageTitle([]);
    this.setPageTitle(this.$t("Other Products"));
  },
};
</script>
<style lang="scss" scoped>
.description {
  font-weight: 500;
  color: white;
}
.b-card {
  width: 90%;
  max-width: 350px;

  .button {
    position: relative;
  }
  .try-now {
    width: 100%;
  }
}
.card-body {
  padding-bottom: 8px;
}

ul li:before {
  content: "\2713";
  color: #00baa0;
  padding: 0 6px 0 0;
}

ul li {
  list-style-type: none;
  font-size: 14px;
}
</style>
